module.exports = __webpack_public_path__ + "static/kawatea-3fa4f14e63f629c00fe024f7bf223f6e.jpg";